/* unplugin-vue-components disabled */import script from "./Resetpassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./Resetpassword.vue?vue&type=script&setup=true&lang=ts"

import "./Resetpassword.vue?vue&type=style&index=0&id=4d96e722&lang=stylus"

const __exports__ = script;

export default __exports__